import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('hook_use_branding_title');

/**
 * Custom hook để set document.title với branding company name
 * @param pageTitle - Tên trang (vd: "Đăng nhập", "Quản lý người dùng")
 * @param defaultSuffix - Suffix mặc định nếu không có branding (default: "Phần mềm xổ sổ")
 */
export const useBrandingTitle = (pageTitle: string, defaultSuffix: string = st('phan_mem_xo_so_text')) => {
  const selectBrandingState = (state: any) => state.BrandingConfiguration;
  const brandingData = createSelector(
    selectBrandingState,
    (state) => ({
      companyName: state.config?.companyName,
    })
  );
  const { companyName } = useSelector(brandingData);

  useEffect(() => {
    if (companyName) {
      document.title = `${pageTitle} | ${companyName}`;
    } else {
      document.title = `${pageTitle} | ${defaultSuffix}`;
    }
  }, [pageTitle, companyName, defaultSuffix]);
};
